import BlockHomeImg from './BlockHomeImg';
export default BlockHomeImg;
